import { render } from "./Map.vue?vue&type=template&id=19187e9e"
import script from "./Map.vue?vue&type=script&lang=js"
export * from "./Map.vue?vue&type=script&lang=js"

import "./Map.vue?vue&type=style&index=0&id=19187e9e&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__